import { useState } from "react";
import { SCHEDULE } from "../data/site";
import { Reveal, Label, BookButton, INTERESTED_URL } from "../components/ui-kit";

const COLORS = {
  "Group Class": "border-gold/40 bg-gold/10 text-gold",
  "Hybrid Training Club": "border-gold/40 bg-gold/10 text-gold",
  Strength: "border-lightgrey/30 bg-white/5 text-lightgrey",
};

const PRIVATE_BADGE = "border-white/20 bg-white/5 text-white/70";

export default function Schedule() {
  const [day, setDay] = useState("Monday");
  return (
    <>
      <section className="pt-40 pb-16 bg-black" data-testid="schedule-hero">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Label>Weekly Schedule</Label>
          <h1 className="font-display uppercase text-white text-5xl md:text-8xl leading-[0.9] mt-6">Find your time.</h1>
          <p className="mt-6 text-lg text-lightgrey max-w-2xl">Early birds and lunch breakers — we've got a class that fits your day. New members always start with a free intro.</p>
        </div>
      </section>

      <section className="bg-black pb-24">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="flex flex-wrap gap-2 mb-10">
            {SCHEDULE.days.map((d) => (
              <button
                key={d}
                onClick={() => setDay(d)}
                data-testid={`day-${d.toLowerCase()}`}
                className={`px-5 py-2.5 rounded-full text-sm font-bold uppercase tracking-wide transition ${day === d ? "bg-gold text-black" : "border border-white/15 text-lightgrey hover:border-gold hover:text-gold"}`}
              >
                {d}
              </button>
            ))}
          </div>

          <Reveal key={day}>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {SCHEDULE.classes[day].map((c, i) => (
                <div key={i} className="rounded-2xl border border-white/10 bg-charcoal p-6 flex items-start justify-between gap-3 hover:border-gold/40 transition" data-testid={`class-${day.toLowerCase()}-${i}`}>
                  <div>
                    <p className="font-display text-2xl md:text-3xl text-white leading-none">{c.t}<span className="text-white/40"> – {c.end}</span></p>
                    <p className="text-sm font-bold text-lightgrey mt-2">{c.n}</p>
                    <p className="text-xs text-white/40 mt-1">{c.private ? "Private youth session" : "All levels welcome"}</p>
                  </div>
                  <span className={`text-[10px] font-bold uppercase tracking-wide px-3 py-1.5 rounded-full border shrink-0 ${c.private ? PRIVATE_BADGE : COLORS[c.n]}`}>{c.private ? "Private · Youth" : c.n}</span>
                </div>
              ))}
            </div>
          </Reveal>

          <div className="mt-16 rounded-3xl border border-gold/30 bg-gradient-to-r from-gold/10 to-transparent p-10 text-center">
            <h2 className="font-display text-3xl md:text-5xl text-white uppercase">Want to try a class?</h2>
            <p className="mt-3 text-lightgrey">Your first visit is always a free, no-pressure intro.</p>
            <div className="mt-8 flex justify-center"><BookButton href={INTERESTED_URL} testid="schedule-book">Book a Free Intro</BookButton></div>
          </div>
        </div>
      </section>
    </>
  );
}
